import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@condition rule-id, Термин на русском}
export const ConditionPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'rule'} params={{id}} title={title} className={linkClass('condition')}>
			{title}
		</Link>
	);
};
